<template>
  <div>
    <div class="flex pt4 pointer" @click="showDetails = !showDetails">
      <h2 class="f3 flex-grow">{{header}}</h2>
      <div class="f3">{{ showDetails? '-' : '+' }}</div>
    </div>
    <div v-show="showDetails">
      <slot>
      </slot>
    </div>
    <hr class="mt3"/>
  </div>

</template>

<script>
export default {
  data () {
    return {
      showDetails: false
    }
  },
  props: {
    header: {
      type: String,
      required: true
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// FaqSection.vue?0432913e